import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from "@angular/router";
import {inject} from "@angular/core";
import {AccountService} from "../account/account.service";


export const isLoginGuard: CanActivateFn = (route, state) => {
  const accountService = inject(AccountService);
  const router = inject(Router);

  return accountService.isLoggedIn() ? router.parseUrl('/cabinet') : true;
}

export const isUserAuthenticated: CanActivateFn =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const accountService = inject(AccountService);
    const router = inject(Router);

    if (accountService.isLoggedIn()) {
      return true;
    } else {
      return router.parseUrl('/login');
    }
  }

  export const isUserActive: CanActivateFn =
    (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const accountService = inject(AccountService);
    const router = inject(Router);

    if (accountService.isLoggedIn() && accountService.user()?.user.status === 'ACTIVE') {
      return true;
    } else {
      return router.parseUrl('/cabinet/verification');
    }
  }
